import { render, staticRenderFns } from "./InstaplayGames.vue?vue&type=template&id=23399484&scoped=true"
import script from "./InstaplayGames.vue?vue&type=script&lang=js"
export * from "./InstaplayGames.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./InstaplayGames.vue?vue&type=style&index=1&id=23399484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23399484",
  null
  
)

export default component.exports